import { CarBookingDetailController } from "./car-booking-detail.controller";

export class CarBookingDetailComponent {
  controller: any = CarBookingDetailController;
  templateUrl: string = "/html/cars/success_page";
}

angular.module("BookingApp").component('carBookingDetailComponent', new CarBookingDetailComponent())
